import React, {useEffect, useState} from 'react';
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {Button, Modal} from 'antd';
import {useHistory} from "react-router-dom";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";
import Collapse from "@mui/material/Collapse";

const Application = () => {
    let history = useHistory()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalRemove, setIsModalRemove] = useState(false);
    const [isModalOpenItem, setIsModalOpenItem] = useState(null);
    const [isModalOpenItemType, setIsModalOpenItemType] = useState("");
    const [data, setData] = useState([])
    const [selCol, setSelCol] = useState([]);

    const handleCancelDelete = () => {
        setIsModalOpen(false);
    };

    const getAll = () => {
        // https://apis.cradle-vision.com/service/all
        axios.get(API_PATH + "service/company/" +  localStorage.getItem('id') + "/service-application-status", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                setData(res?.data)
            })
    }
    const showModalDelete = (id, type) => {
        setIsModalRemove(true);
        setIsModalOpenItem(id)
        setIsModalOpenItemType(type)
    };

    const deleteMenu = () => {
        if (isModalOpenItemType === "true"){
            axios.post(API_PATH + "service/company/" + localStorage.getItem("id") + "/application/",{service_id: isModalOpenItem, application_type: "off"}, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res =>{
                    toast.success("SUCCESS")
                    getAll()
                    setIsModalRemove(false);
                })
        } else {
            axios.delete(API_PATH + "service/company/" + localStorage.getItem("id") + "/application/?services_id=" + isModalOpenItem, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res =>{
                    toast.success("SUCCESS")
                    getAll()
                    setIsModalRemove(false);
                })
        }
    };

    const addmenu = () => {
        axios.post(API_PATH + "service/company/" + localStorage.getItem("id") + "/application/", {service_id: isModalOpenItem, application_type: "on"},{headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                toast.success("SUCCESS")
                getAll()
                setIsModalOpen(false)
            })
    };
    const removeItem = (id) => {

        if(selCol.indexOf(id) < 0){

            setSelCol([...selCol, id])
        } else {
            setSelCol(selCol?.filter(item => item != id))
        }
    }

    useEffect(() => {
        getAll()
    }, []);

    return (
        <div className="users">
            <div className="employees-header">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="left-head">
                        <h6 className="font-family-medium">Услуги</h6>
                    </div>
                    <div className="right-head">
                        {/*<button className="upload-btn font-family-medium ml-16 mr-16"><img*/}
                        {/*    src="/icon/upload.svg"/> Экспорт в Excel*/}
                        {/*</button>*/}
                        {/*<button className="add-btn font-family-medium" ><img src="/icon/plus.svg"*/}
                        {/*                                                                         alt="+"/> Добавить*/}
                        {/*    новое*/}
                        {/*</button>*/}
                    </div>
                </div>
            </div>
            <div className="emp-table">
                <TableContainer component={Paper}>
                    <Table sx={{minWidth: 650}} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className="table-head">Название</TableCell>
                                <TableCell className="table-head"></TableCell>
                                <TableCell className="table-head"></TableCell>
                                {/*<TableCell className="table-head" >Интервал</TableCell>*/}
                                <TableCell className="table-head" align="right">Действие</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                data?.map((item, index) =>(
                                    <>
                                    <TableRow
                                        sx={{'&:last-child td, &:last-child th': {border: 0}}}

                                        className="cursor-pointer"
                                        onClick={() => removeItem(index)}
                                    >
                                        <TableCell component="th" scope="row">
                                            <span className="t-name d-flex align-items-center font-family-medium"> <div className={item?.status === "true"  ? "my-light mr-8" : item?.status === "false" ? "my-inlight mr-8" : item?.status === "application_on" || item?.status === "application_off" ? "my-prolight mr-8" : ""}></div>{item?.title}</span>
                                        </TableCell>
                                        <TableCell className="twt"><span className="font-family-medium"> </span></TableCell>
                                        <TableCell className="twt"><span className="font-family-medium"> </span></TableCell>
                                        <TableCell className="twt" align="right">
                                            <div>
                                                <button className={item?.status === "true"  ? "app-add-inactive-btn mr-16 font-family-medium" : item?.status === "false" ? "app-add-active-btn mr-16 font-family-medium" : item?.status === "application_on" || item?.status === "application_off" ? "app-add-inactive-btn mr-16 font-family-medium" : ""}
                                                        disabled={item?.status === "true"  ? true : item?.status === "false"  ? false :  item?.status === "application_on" || item?.status === "application_off" }
                                                        onClick={() => {
                                                            setIsModalOpen(true)
                                                            setIsModalOpenItem(item?.id)
                                                        }}
                                                >
                                                    Применять
                                                </button>
                                                {
                                                    item?.status === "true"
                                                    ?
                                                        <button className="app-add-remove-btn"
                                                                onClick={() => showModalDelete(item?.id, item?.status)}
                                                        >
                                                            Удалять
                                                        </button>
                                                        :
                                                        ""
                                                }
                                                {
                                                    item?.status === "false"
                                                        ?
                                                        <button className="app-add-inremove-btn"
                                                                disabled={true}
                                                        >
                                                            Удалять
                                                        </button>
                                                        :
                                                        ""
                                                }
                                                {
                                                    item?.status === "application_on" || item?.status === "application_off"
                                                        ?
                                                        <button className="app-add-remove-btn"
                                                                onClick={() => showModalDelete(item?.id, item?.status)}
                                                        >
                                                            Отмена
                                                        </button>
                                                        :
                                                        ""
                                                }
                                            </div>
                                        </TableCell>
                                    </TableRow>

                                        <TableRow>
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                <Collapse in={selCol?.filter(item2 => item2 === index)?.length > 0} timeout="auto" unmountOnExit>
                                                    {
                                                        item?.service_parts?.map(item3 => (
                                                            <p className="text-white mt-2 mb-2">
                                                                {item3?.name}
                                                            </p>
                                                        ))
                                                    }
                                                </Collapse>
                                            </TableCell>
                                        </TableRow>
                                    </>
                                ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <Modal title="Внимание!"
                   open={isModalOpen}
                   onCancel={handleCancelDelete}
                   footer={[
                       <Button key="submit" type="default" onClick={handleCancelDelete}>
                           Отменить
                       </Button>,
                       <Button key="submit" type="primary" className="my-red-canc " onClick={addmenu}>
                           Да
                       </Button>
                   ]}
            >
                <p className="pt-2 pb-2 text-white">Хотите использовать эту функцию?</p>
            </Modal>
            <Modal title="Внимание!"
                   open={isModalRemove}
                   onCancel={() => setIsModalRemove(false)}
                   footer={[
                       <Button key="submit" type="default" onClick={() => setIsModalRemove(false)}>
                           Отменить
                       </Button>,
                       <Button key="submit" onClick={deleteMenu} type="danger" className="my-red-canc app-add-remove-btn">
                           Да
                       </Button>
                   ]}
            >
                <p className="pt-2 pb-2 text-white">Вы уверены, что удалите этого функция?</p>
            </Modal>
        </div>
    );
};

export default Application;